(function () {
  'use strict';

  function initialiseUnifiedVideos(root) {
    if (!root || root.dataset.mgvReady === 'true') return;

    var experience = root.querySelector('[data-mgv-experience]');
    var viewport = root.querySelector('[data-mgv-viewport]');
    var track = root.querySelector('[data-mgv-track]');
    var carouselPrevious = root.querySelector('[data-mgv-carousel-previous]');
    var carouselNext = root.querySelector('[data-mgv-carousel-next]');

    var modal = root.querySelector('[data-mgv-modal]');
    var reel = root.querySelector('[data-mgv-reel]');
    var paneCurrent = root.querySelector('[data-mgv-pane-current]');
    var modalSlot = root.querySelector('[data-mgv-modal-slot]');
    var posterPrevious = root.querySelector('[data-mgv-modal-poster-previous]');
    var posterCurrent = root.querySelector('[data-mgv-modal-poster-current]');
    var posterNext = root.querySelector('[data-mgv-modal-poster-next]');
    var modalClose = root.querySelector('[data-mgv-modal-close]');
    var modalMute = root.querySelector('[data-mgv-modal-mute]');
    var modalMutedIcon = root.querySelector('[data-mgv-modal-muted-icon]');
    var modalSoundIcon = root.querySelector('[data-mgv-modal-sound-icon]');
    var modalPrevious = root.querySelector('[data-mgv-modal-previous]');
    var modalNext = root.querySelector('[data-mgv-modal-next]');
    var modalNavigation = root.querySelector('[data-mgv-modal-navigation]');
    var modalPlay = root.querySelector('[data-mgv-modal-play]');
    var modalLoader = root.querySelector('[data-mgv-modal-loader]');
    var unmuteNotice = root.querySelector('[data-mgv-unmute-notice]');
    var shareButton = root.querySelector('[data-mgv-share]');
    var shopButton = root.querySelector('[data-mgv-shop]');
    var message = root.querySelector('[data-mgv-message]');

    if (
      !experience ||
      !viewport ||
      !track ||
      !modal ||
      !reel ||
      !modalSlot
    ) {
      return;
    }

    var originalSlides = Array.prototype.slice.call(
      track.querySelectorAll('[data-mgv-slide]')
    );

    originalSlides = originalSlides.filter(function (slide) {
      if (slide.dataset.videoSrc) return true;
      slide.remove();
      return false;
    });

    if (!originalSlides.length) return;

    root.dataset.mgvReady = 'true';

    var items = originalSlides.map(function (slide, index) {
      slide.dataset.index = String(index);

      return {
        id: String(slide.dataset.videoId || index),
        src: slide.dataset.videoSrc,
        inlineSrc: slide.dataset.videoInlineSrc || slide.dataset.videoSrc,
        posterSmall: slide.dataset.posterSmall || '',
        posterCard: slide.dataset.posterCard || '',
        posterFull:
          slide.dataset.posterFull ||
          slide.dataset.posterCard ||
          slide.dataset.posterSmall || ''
      };
    });

    var count = items.length;
    var activeIndex = count > 1 ? 1 : 0;

    if (count === 1) {
      root.classList.add('is-single');
      if (modalNavigation) modalNavigation.hidden = true;
    }

    function wrapIndex(index) {
      return (index + count) % count;
    }

    function prepareClone(slide, setName) {
      var clone = slide.cloneNode(true);
      var buttons = clone.querySelectorAll('button');

      clone.dataset.mgvClone = setName;
      clone.setAttribute('aria-hidden', 'true');

      buttons.forEach(function (button) {
        button.tabIndex = -1;
      });

      return clone;
    }

    if (count > 1) {
      var beforeFragment = document.createDocumentFragment();
      var afterFragment = document.createDocumentFragment();

      originalSlides.forEach(function (slide) {
        beforeFragment.appendChild(prepareClone(slide, 'before'));
        afterFragment.appendChild(prepareClone(slide, 'after'));
      });

      track.insertBefore(beforeFragment, track.firstChild);
      track.appendChild(afterFragment);
    }

    var allSlides = Array.prototype.slice.call(
      track.querySelectorAll('[data-mgv-slide]')
    );

    allSlides.forEach(function (slide, index) {
      slide.dataset.virtualIndex = String(index);
    });

    var virtualIndex = count > 1 ? count + activeIndex : 0;
    var pendingUserInitiated = false;
    var carouselMoving = false;
    var carouselTimer = null;
    var resizeTimer = null;
    var ignoreClicksUntil = 0;

    var drag = {
      pointerId: null,
      startX: 0,
      startY: 0,
      startTime: 0,
      deltaX: 0,
      horizontal: false
    };

    var modalOpen = false;
    var sectionVisible = false;
    var networkAllowed = document.readyState === 'complete';
    var loadedIndex = -1;
    var loadedSource = '';
    var sourceGeneration = 0;
    var soundOn = false;
    var unmutePromptShown = false;
    var unmuteTimer = null;
    var messageTimer = null;
    var networkStarted = false;
    var resumeTimer = null;
    var mainPauseGuardUntil = 0;

    var reelBusy = false;
    var reelTimer = null;
    var reelPointerStartY = 0;
    var reelPointerMoved = false;
    var reelPointerDown = false;

    var savedScrollY = 0;
    var savedBodyStyle = {};
    var savedHtmlStyle = {};

    var lastLayoutWidth = window.innerWidth;

    /* Player 1: Experience Luxury + fullscreen. */
    var video = document.createElement('video');
    video.className = 'mgv__video';
    video.loop = true;
    video.playsInline = true;
    video.preload = 'none';
    video.muted = true;
    video.defaultMuted = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.setAttribute('aria-label', 'Product video');

    document.body.appendChild(modal);

    /*
      Never overwrite HTMLMediaElement.pause(). Dawn may pause every video
      after a gallery interaction, so distinguish our own pauses from an
      external pause and recover only players that should currently run.
    */
    function pauseMainInternally() {
      mainPauseGuardUntil = Date.now() + 500;
      try { video.pause(); } catch (error) {}
    }

    function currentItem() {
      return items[activeIndex];
    }

    function currentSlide() {
      return allSlides[virtualIndex] || allSlides[count + activeIndex] || allSlides[0];
    }

    function currentInlineSlot() {
      var slide = currentSlide();
      return slide ? slide.querySelector('[data-mgv-inline-slot]') : null;
    }

    function setImage(image, source) {
      if (!image) return;
      if (!source) {
        image.removeAttribute('src');
        return;
      }
      if (image.getAttribute('src') !== source) {
        image.setAttribute('src', source);
      }
    }

    function setModalPoster(image, item, upgradeToFull) {
      if (!image || !item) return;
      var fallback = item.posterCard || item.posterSmall || item.posterFull;
      var full = item.posterFull || fallback;

      image.dataset.videoId = item.id;
      setImage(image, fallback);

      if (!upgradeToFull || !full || full === fallback) return;

      var preload = new Image();
      preload.decoding = 'async';
      preload.onload = function () {
        if (image.dataset.videoId === item.id) {
          setImage(image, full);
        }
      };
      preload.src = full;
    }

    function carouselTranslate(deltaX) {
      var slide = allSlides[virtualIndex];
      if (!slide) return 0;
      return (viewport.clientWidth / 2 - (slide.offsetLeft + slide.offsetWidth / 2) + (deltaX || 0));
    }

    function positionCarousel(animate, deltaX) {
      track.style.transition = animate ? 'transform 320ms cubic-bezier(0.25, 1, 0.5, 1)' : 'none';
      track.style.transform = 'translate3d(' + carouselTranslate(deltaX) + 'px, 0, 0)';
    }

    function updateSlideStates() {
      allSlides.forEach(function (slide, index) {
        var active = index === virtualIndex;
        var muteButton = slide.querySelector('[data-mgv-inline-mute]');
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-current', active ? 'true' : 'false');
        if (muteButton) muteButton.hidden = !active || !sectionVisible || modalOpen;
      });
      updateMuteUI();
    }

    function normaliseVirtualIndex() {
      if (count < 2) return;
      if (virtualIndex < count) virtualIndex += count;
      else if (virtualIndex >= count * 2) virtualIndex -= count;
    }

    function finishCarouselMove() {
      if (!carouselMoving) return;
      carouselMoving = false;
      window.clearTimeout(carouselTimer);
      normaliseVirtualIndex();
      activeIndex = wrapIndex(Number(allSlides[virtualIndex].dataset.index || 0));
      positionCarousel(false, 0);
      updateSlideStates();
      activeItemChanged(pendingUserInitiated);
      pendingUserInitiated = false;
    }

    function moveCarouselTo(nextVirtualIndex, animate, userInitiated) {
      if (count < 2) return;
      virtualIndex = Math.max(0, Math.min(allSlides.length - 1, nextVirtualIndex));
      activeIndex = wrapIndex(Number(allSlides[virtualIndex].dataset.index || 0));
      pendingUserInitiated = Boolean(userInitiated);
      carouselMoving = true;
      updateSlideStates();
      positionCarousel(Boolean(animate), 0);
      window.clearTimeout(carouselTimer);
      if (animate) {
        carouselTimer = window.setTimeout(finishCarouselMove, 280);
      } else {
        finishCarouselMove();
      }
    }

    function updateMuteUI() {
      allSlides.forEach(function (slide) {
        var button = slide.querySelector('[data-mgv-inline-mute]');
        var mutedIcon = slide.querySelector('[data-mgv-muted-icon]');
        var soundIcon = slide.querySelector('[data-mgv-sound-icon]');
        if (!button || !mutedIcon || !soundIcon) return;
        mutedIcon.hidden = soundOn;
        soundIcon.hidden = !soundOn;
        button.setAttribute('aria-label', soundOn ? 'Mute video' : 'Unmute video');
      });

      if (modalMutedIcon && modalSoundIcon && modalMute) {
        modalMutedIcon.hidden = soundOn;
        modalSoundIcon.hidden = !soundOn;
        modalMute.setAttribute('aria-label', soundOn ? 'Mute video' : 'Unmute video');
      }
    }

    function playerDestination() {
      if (modalOpen) return modalSlot;
      if (sectionVisible) return currentInlineSlot();
      return null;
    }

    function attachPlayer() {
      var destination = playerDestination();
      if (!destination) {
        pauseMainInternally();
        return false;
      }
      if (video.parentNode !== destination) {
        destination.appendChild(video);
      }
      return true;
    }

    function showPlayFallback() {
      if (modalOpen) modalPlay.hidden = false;
    }

    function hidePlayFallback() {
      modalPlay.hidden = true;
    }

    function attemptPlay() {
      if (document.hidden) return;
      var request;
      try {
        request = video.play();
      } catch (error) {
        showPlayFallback();
        return;
      }
      if (request && typeof request.catch === 'function') {
        request.catch(showPlayFallback);
      }
    }

    function loadActiveSource(userInitiated) {
      if (!networkAllowed && !userInitiated) return;
      if (!attachPlayer()) return;

      var desiredSource = modalOpen
        ? currentItem().src
        : currentItem().inlineSrc;

      if (loadedIndex !== activeIndex || loadedSource !== desiredSource) {
        pauseMainInternally();
        sourceGeneration += 1;
        video.classList.remove('is-frame-ready');
        video.setAttribute('aria-busy', 'true');
        hidePlayFallback();
        if (modalLoader && modalOpen) modalLoader.hidden = false;

        video.removeAttribute('poster');
        video.src = desiredSource;
        video.preload = modalOpen ? 'auto' : 'metadata';
        video.load();
        loadedIndex = activeIndex;
        loadedSource = desiredSource;
      }

      video.muted = !soundOn;
      video.defaultMuted = !soundOn;

      if (
        userInitiated ||
        modalOpen ||
        sectionVisible
      ) {
        attemptPlay();
      }
    }

    function revealVideoFrame() {
      var expectedIndex = loadedIndex;
      var expectedGeneration = sourceGeneration;
      var expectedSource = loadedSource;

      var reveal = function () {
        if (
          expectedIndex !== loadedIndex ||
          expectedGeneration !== sourceGeneration ||
          expectedSource !== loadedSource ||
          video.readyState < 2
        ) {
          return;
        }

        video.classList.add('is-frame-ready');
        video.removeAttribute('aria-busy');
        hidePlayFallback();
        if (modalLoader) modalLoader.hidden = true;
      };

      if (typeof video.requestVideoFrameCallback === 'function') {
        video.requestVideoFrameCallback(reveal);
      } else {
        window.requestAnimationFrame(reveal);
      }
    }

    function updateModalPosters() {
      var previous = items[wrapIndex(activeIndex - 1)];
      var current = items[activeIndex];
      var next = items[wrapIndex(activeIndex + 1)];

      setModalPoster(posterPrevious, previous, true);
      setModalPoster(posterCurrent, current, true);
      setModalPoster(posterNext, next, true);
    }

    function activeItemChanged(userInitiated) {
      if (modalOpen) updateModalPosters();
      attachPlayer();
      loadActiveSource(Boolean(userInitiated));
    }

    function toggleSound() {
      soundOn = !soundOn;
      video.muted = !soundOn;
      video.defaultMuted = !soundOn;
      hideUnmuteNotice();
      updateMuteUI();
      if (video.paused) attemptPlay();
    }

    function showUnmuteNotice() {
      if (soundOn || unmutePromptShown) return;
      unmutePromptShown = true;
      unmuteNotice.hidden = false;
      unmuteNotice.setAttribute('aria-hidden', 'false');
      window.clearTimeout(unmuteTimer);
      unmuteTimer = window.setTimeout(function () {
        unmuteNotice.hidden = true;
        unmuteNotice.setAttribute('aria-hidden', 'true');
      }, 3200);
    }

    function hideUnmuteNotice() {
      window.clearTimeout(unmuteTimer);
      unmuteNotice.hidden = true;
      unmuteNotice.setAttribute('aria-hidden', 'true');
    }

    function lockPage() {
      savedScrollY = window.scrollY || document.documentElement.scrollTop || 0;
      savedBodyStyle = {
        position: document.body.style.position,
        top: document.body.style.top,
        left: document.body.style.left,
        right: document.body.style.right,
        width: document.body.style.width,
        overflow: document.body.style.overflow
      };
      savedHtmlStyle = {
        overflow: document.documentElement.style.overflow,
        overscrollBehavior: document.documentElement.style.overscrollBehavior
      };
      document.documentElement.style.overflow = 'hidden';
      document.documentElement.style.overscrollBehavior = 'none';
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + savedScrollY + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
    }

    function unlockPage() {
      document.documentElement.style.overflow = savedHtmlStyle.overflow || '';
      document.documentElement.style.overscrollBehavior = savedHtmlStyle.overscrollBehavior || '';
      document.body.style.position = savedBodyStyle.position || '';
      document.body.style.top = savedBodyStyle.top || '';
      document.body.style.left = savedBodyStyle.left || '';
      document.body.style.right = savedBodyStyle.right || '';
      document.body.style.width = savedBodyStyle.width || '';
      document.body.style.overflow = savedBodyStyle.overflow || '';
      window.scrollTo(0, savedScrollY);
    }

    function reelHeight() {
      return Math.max(1, reel.clientHeight);
    }

    function centreReelImmediately() {
      var previousSnap = reel.style.scrollSnapType;
      reel.style.scrollBehavior = 'auto';
      reel.style.scrollSnapType = 'none';
      reel.scrollTop = reelHeight();
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          reel.style.scrollSnapType = previousSnap;
          reel.style.scrollBehavior = '';
        });
      });
    }

    function commitReelDirection(direction) {
      if (!modalOpen || reelBusy || count < 2) return;
      reelBusy = true;
      var targetIndex = wrapIndex(activeIndex + direction);
      var targetPoster = items[targetIndex].posterFull;

      pauseMainInternally();
      video.classList.remove('is-frame-ready');

      posterCurrent.dataset.videoId = items[targetIndex].id;
      setImage(posterCurrent, items[targetIndex].posterCard || items[targetIndex].posterSmall || targetPoster);
      centreReelImmediately();

      activeIndex = targetIndex;
      virtualIndex = count > 1 ? count + activeIndex : 0;
      updateSlideStates();
      positionCarousel(false, 0);
      updateModalPosters();
      loadActiveSource(true);

      window.setTimeout(function () {
        reelBusy = false;
      }, 180);
    }

    function settleReel() {
      if (!modalOpen || reelBusy || reelPointerDown) return;
      var height = reelHeight();
      var page = Math.round(reel.scrollTop / height);

      if (page <= 0) {
        commitReelDirection(-1);
        return;
      }
      if (page >= 2) {
        commitReelDirection(1);
        return;
      }
      if (Math.abs(reel.scrollTop - height) > 1) {
        reel.scrollTo({ top: height, behavior: 'smooth' });
      } else {
        if (video.paused && video.classList.contains('is-frame-ready')) attemptPlay();
      }
    }

    function animateReel(direction) {
      if (!modalOpen || reelBusy || count < 2) return;
      reel.scrollTo({ top: direction > 0 ? reelHeight() * 2 : 0, behavior: 'smooth' });
      window.clearTimeout(reelTimer);
      reelTimer = window.setTimeout(settleReel, 300);
    }

    function openModal() {
      if (modalOpen) return;

      modalOpen = true;
      root.classList.add('is-modal-open');

      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');

      lockPage();
      updateModalPosters();
      centreReelImmediately();
      updateSlideStates();
      unmutePromptShown = false;
      
      
      loadActiveSource(true);

      showUnmuteNotice();
    }

    function closeModal(returnFocus) {
      if (!modalOpen) return;

      hideUnmuteNotice();
      window.clearTimeout(reelTimer);

      modalOpen = false;
      root.classList.remove('is-modal-open');
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');

      soundOn = false;
      pauseMainInternally();
      video.muted = true;
      video.defaultMuted = true;

      unlockPage();
      updateSlideStates();
      updateMuteUI();
      attachPlayer();
      loadActiveSource(false);


      if (returnFocus !== false) {
        var focusTarget = currentSlide().querySelector('[data-mgv-card]');
        if (focusTarget) focusTarget.focus();
      }
    }

    function cleanProductUrl() {
      return window.location.origin + window.location.pathname;
    }

    function showMessage(text) {
      window.clearTimeout(messageTimer);
      message.textContent = text;
      message.hidden = false;
      messageTimer = window.setTimeout(function () { message.hidden = true; }, 1800);
    }

    function fallbackCopy(text) {
      var textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      try { document.execCommand('copy'); } catch (error) {}
      textarea.remove();
      showMessage('Link copied');
    }

    function shareProduct() {
      var url = cleanProductUrl();
      var title = root.dataset.productTitle || document.title;
      if (navigator.share) {
        navigator.share({ title: title, text: 'Check out ' + title, url: url }).catch(function (error) {
          if (error && error.name !== 'AbortError') fallbackCopy(url);
        });
        return;
      }
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(url).then(function () { showMessage('Link copied'); }).catch(function () { fallbackCopy(url); });
        return;
      }
      fallbackCopy(url);
    }

    function findSizeSelector() {
      var fields = document.querySelectorAll('variant-selects .product-form__input, variant-radios .product-form__input, .product-form__input');
      for (var index = 0; index < fields.length; index += 1) {
        var label = fields[index].querySelector('legend, label.form__label');
        var text = label ? label.textContent.toLowerCase() : '';
        if (text.indexOf('size') !== -1) return fields[index];
      }
      return fields[0] || null;
    }

    function scrollToSizeSelector() {
      var target = findSizeSelector();
      closeModal(false);
      if (!target) return;
      window.setTimeout(function () {
        var gap = window.innerWidth < 750 ? 110 : 130;
        var top = target.getBoundingClientRect().top + window.scrollY - gap;
        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      }, 120);
    }

    viewport.addEventListener('pointerdown', function (event) {
      if (count < 2) return; 
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      if (event.pointerType === 'touch' && (event.clientX < 24 || event.clientX > window.innerWidth - 24)) return;
      if (carouselMoving) finishCarouselMove();
      drag.pointerId = event.pointerId;
      drag.startX = event.clientX;
      drag.startY = event.clientY;
      drag.startTime = Date.now();
      drag.deltaX = 0;
      drag.horizontal = false;
      track.style.transition = 'none';
    });

    viewport.addEventListener('pointermove', function (event) {
      if (event.pointerId !== drag.pointerId) return;
      var deltaX = event.clientX - drag.startX;
      var deltaY = event.clientY - drag.startY;
      var absX = Math.abs(deltaX);
      var absY = Math.abs(deltaY);

      if (!drag.horizontal) {
        if (absX < 4 && absY < 4) return;
        if (absY > absX) {
          drag.pointerId = null;
          track.style.transition = '';
          return;
        }
        if (absX < absY * 1.15) return;
        drag.horizontal = true;
        viewport.classList.add('is-dragging');
        try { viewport.setPointerCapture(event.pointerId); } catch (error) {}
      }
      if (drag.horizontal) {
        if (event.cancelable) event.preventDefault();
        drag.deltaX = deltaX;
        positionCarousel(false, deltaX);
      }
    }, { passive: false });

    function finishPointerGesture(event, cancelled) {
      if (event.pointerId !== drag.pointerId) return;
      var wasHorizontal = drag.horizontal;
      var deltaX = drag.deltaX;
      var elapsed = Math.max(1, Date.now() - drag.startTime);
      var velocity = deltaX / elapsed;

      drag.pointerId = null;
      drag.horizontal = false;
      drag.deltaX = 0;
      viewport.classList.remove('is-dragging');

      if (!wasHorizontal) {
        positionCarousel(false, 0);
        return;
      }
      ignoreClicksUntil = Date.now() + 350;
      var threshold = 25; 
      var shouldChange = Math.abs(deltaX) >= threshold || (Math.abs(deltaX) >= 8 && Math.abs(velocity) >= 0.12);

      if (!shouldChange) {
        positionCarousel(true, 0);
        return;
      }
      moveCarouselTo(virtualIndex + (deltaX < 0 ? 1 : -1), true, true);
    }

    viewport.addEventListener('pointerup', function (event) { finishPointerGesture(event, false); });
    viewport.addEventListener('pointercancel', function (event) { finishPointerGesture(event, true); });
    track.addEventListener('transitionend', function (event) { if (event.propertyName === 'transform') finishCarouselMove(); });

    viewport.addEventListener('click', function (event) {
      var muteButton = event.target.closest('[data-mgv-inline-mute]');
      if (muteButton) {
        event.preventDefault();
        event.stopPropagation();
        var muteSlide = muteButton.closest('[data-mgv-slide]');
        var muteVirtual = Number(muteSlide.dataset.virtualIndex || 0);
        if (muteVirtual !== virtualIndex) {
          moveCarouselTo(muteVirtual, true, true);
          return;
        }
        toggleSound();
        return;
      }
      var card = event.target.closest('[data-mgv-card]');
      if (!card || Date.now() < ignoreClicksUntil) return;
      var slide = card.closest('[data-mgv-slide]');
      var selectedVirtual = Number(slide.dataset.virtualIndex || 0);
      if (selectedVirtual !== virtualIndex) {
        moveCarouselTo(selectedVirtual, true, true);
        return;
      }
      openModal();
    });

    carouselPrevious.addEventListener('click', function () { moveCarouselTo(virtualIndex - 1, true, true); });
    carouselNext.addEventListener('click', function () { moveCarouselTo(virtualIndex + 1, true, true); });
    modalClose.addEventListener('click', function (event) {
      closeModal(event.detail === 0);
    });
    modalMute.addEventListener('click', toggleSound);
    modalPrevious.addEventListener('click', function () { animateReel(-1); });
    modalNext.addEventListener('click', function () { animateReel(1); });
    modalPlay.addEventListener('click', function () { hidePlayFallback(); attemptPlay(); });
    shareButton.addEventListener('click', shareProduct);
    shopButton.addEventListener('click', scrollToSizeSelector);

    reel.addEventListener('scroll', function () {
      if (!modalOpen || reelBusy) return;
      var height = reelHeight();
      var currentScroll = reel.scrollTop;
      if (!video.paused && Math.abs(currentScroll - height) > 15) pauseMainInternally();
      window.clearTimeout(reelTimer);
      if (!reelPointerDown) {
        if (currentScroll <= 2) { commitReelDirection(-1); return; } 
        else if (currentScroll >= (height * 2) - 2) { commitReelDirection(1); return; }
      }
      reelTimer = window.setTimeout(settleReel, 120);
    });

    reel.addEventListener('scrollend', settleReel);
    reel.addEventListener('touchmove', function (event) { if (count < 2) event.preventDefault(); }, { passive: false });
    reel.addEventListener('wheel', function (event) { if (count < 2) event.preventDefault(); }, { passive: false });

    reel.addEventListener('pointerdown', function (event) {
      reelPointerDown = true;
      reelPointerStartY = event.clientY;
      reelPointerMoved = false;
      window.clearTimeout(reelTimer);
    });

    reel.addEventListener('pointermove', function (event) {
      if (Math.abs(event.clientY - reelPointerStartY) > 10) reelPointerMoved = true;
    });

    reel.addEventListener('pointerup', function () {
      reelPointerDown = false;
      window.clearTimeout(reelTimer);
      reelTimer = window.setTimeout(settleReel, 120);
    });

    reel.addEventListener('pointercancel', function () {
      reelPointerDown = false;
      window.clearTimeout(reelTimer);
      reelTimer = window.setTimeout(settleReel, 120);
    });

    paneCurrent.addEventListener('click', function () {
      if (reelPointerMoved || reelBusy) return;
      if (!soundOn) toggleSound();
      else if (video.paused) attemptPlay();
    });

    video.addEventListener('loadeddata', revealVideoFrame);
    video.addEventListener('playing', revealVideoFrame);
    video.addEventListener('waiting', function () {
      if (modalOpen && modalLoader && !video.paused) modalLoader.hidden = false;
    });
    video.addEventListener('canplay', function () {
      if (!video.paused) revealVideoFrame();
    });
    video.addEventListener('error', function () {
      video.classList.remove('is-frame-ready');
      showPlayFallback();
    });

    /*
      Dawn calls pause() on all page videos when product media changes.
      Recover only when this was not one of our intentional pauses.
    */
    video.addEventListener('pause', function () {
      if (
        Date.now() < mainPauseGuardUntil ||
        document.hidden ||
        (!modalOpen && !sectionVisible)
      ) {
        return;
      }

      window.setTimeout(function () {
        if (
          Date.now() >= mainPauseGuardUntil &&
          !document.hidden &&
          (modalOpen || sectionVisible)
        ) {
          attachPlayer();
          loadActiveSource(false);
        }
      }, 140);
    });

    document.addEventListener('keydown', function (event) {
      if (!modalOpen) return;
      if (event.key === 'Escape') closeModal(true);
      else if (event.key === 'ArrowUp') { event.preventDefault(); animateReel(-1); } 
      else if (event.key === 'ArrowDown') { event.preventDefault(); animateReel(1); }
    });

    function resumeEligiblePlayers() {
      window.clearTimeout(resumeTimer);

      resumeTimer = window.setTimeout(function () {
        if (document.hidden || !networkAllowed) return;

        /* Muted playback is the only cross-device autoplay-safe wake state. */
        soundOn = false;
        video.muted = true;
        video.defaultMuted = true;
        updateMuteUI();


        if (modalOpen || sectionVisible) {
          attachPlayer();
          loadActiveSource(false);
        }
      }, 120);
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        soundOn = false;
        video.muted = true;
        video.defaultMuted = true;
        pauseMainInternally();
        updateMuteUI();
        return;
      }

      resumeEligiblePlayers();
    });

    /* pageshow also fires when Safari restores a page from its back/forward cache. */
    window.addEventListener('pageshow', function () {
      resumeEligiblePlayers();
    });

    window.addEventListener('focus', function () {
      if (!document.hidden) resumeEligiblePlayers();
    });

    function handleExperienceVisibility(entries) {
      entries.forEach(function (entry) {
        var nowVisible = entry.isIntersecting;
        if (nowVisible === sectionVisible) return;
        
        sectionVisible = nowVisible;
        updateSlideStates();

        if (!modalOpen) {
          attachPlayer();
          loadActiveSource(false);
        }
      });
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(handleExperienceVisibility, {
        rootMargin: '-80px 0px',
        threshold: 0
      });
      observer.observe(experience);
    }

    window.addEventListener('resize', function () {
      var nextWidth = window.innerWidth;
      if (Math.abs(nextWidth - lastLayoutWidth) < 3) return;
      lastLayoutWidth = nextWidth;
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        positionCarousel(false, 0);
        if (modalOpen) centreReelImmediately();
      }, 120);
    });

    window.addEventListener('orientationchange', function () {
      lastLayoutWidth = window.innerWidth;
      window.setTimeout(function () {
        positionCarousel(false, 0);
        if (modalOpen) centreReelImmediately();
      }, 260);
    });

    function allowVideoNetwork() {
      if (networkStarted) return;
      networkStarted = true;
      networkAllowed = true;

      if (sectionVisible || modalOpen) {
        attachPlayer();
        loadActiveSource(false);
      }
    }

    function scheduleVideoNetwork() {
      window.setTimeout(allowVideoNetwork, 150);
    }

    updateSlideStates();
    updateMuteUI();

    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () { positionCarousel(false, 0); });
    });

    if (document.readyState === 'complete') {
      scheduleVideoNetwork();
    } else {
      window.addEventListener('load', scheduleVideoNetwork, { once: true });
    }
  }

  function initialiseAll() { document.querySelectorAll('[data-mgv]').forEach(initialiseUnifiedVideos); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialiseAll);
  else initialiseAll();
  document.addEventListener('shopify:section:load', initialiseAll);
})();